import { render, staticRenderFns } from "./Command1.vue?vue&type=template&id=236fad6e"
import script from "./Command1.vue?vue&type=script&lang=js"
export * from "./Command1.vue?vue&type=script&lang=js"
import style0 from "./Command1.vue?vue&type=style&index=0&id=236fad6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports